import { auth } from "./auth.module";
import Vuex from 'vuex'

const store = new Vuex.Store({
    modules: {
        auth,
    },
})

export default store;